import { useEditor } from '@/state/store'
import { COMPOUND_WALL_DEFAULTS } from '@/model/defaults'
import { OPENING_PRESETS_BY_FAMILY } from '@/components/families/presets'

const FAMILY_META: Record<string, { icon: string }> = {
  door:   { icon: '🚪' },
  window: { icon: '🪟' },
  gate:   { icon: '⛩' },
}

/** Picks the opening preset placed by the opening tool, and arms that tool. */
export function OpeningPanel() {
  const activeOpeningPresetId = useEditor((s) => s.activeOpeningPresetId)
  const setActiveOpeningPresetId = useEditor((s) => s.setActiveOpeningPresetId)
  const setTool = useEditor((s) => s.setTool)
  const update = useEditor((s) => s.update)
  const tool = useEditor((s) => s.tool)
  const compoundEnabled = useEditor((s) => s.project.plot.compoundWall?.enabled ?? false)

  function pick(presetId: string, familyId: string) {
    if (familyId === 'gate' && !compoundEnabled) {
      update((d) => {
        d.plot.compoundWall = d.plot.compoundWall
          ? { ...d.plot.compoundWall, enabled: true }
          : { enabled: true, ...COMPOUND_WALL_DEFAULTS, openings: [] }
      })
    }
    setActiveOpeningPresetId(presetId)
    setTool('opening')
  }

  return (
    <section className="panel draw-panel">
      <div className="panel-head">
        <h3>Place opening</h3>
      </div>
      <div className="kind-list">
        {(['door', 'window', 'gate'] as const).flatMap((familyId) =>
          (OPENING_PRESETS_BY_FAMILY[familyId] ?? []).map((preset) => {
            const active = tool === 'opening' && activeOpeningPresetId === preset.id
            const desc = familyId === 'gate' && !compoundEnabled
              ? 'Enables the compound wall, then place the gate.'
              : preset.label
            return (
              <button
                key={preset.id}
                className={`kind-item${active ? ' active' : ''}`}
                onClick={() => pick(preset.id, familyId)}
                title={desc}
              >
                <span className="kind-swatch" style={{ display: 'grid', placeItems: 'center', background: 'transparent' }}>
                  {FAMILY_META[familyId]?.icon ?? '▭'}
                </span>
                <span className="kind-text">
                  <span className="kind-label">{preset.label}</span>
                  <span className="kind-desc">{desc}</span>
                </span>
              </button>
            )
          })
        )}
      </div>
      <p className="hint-note">Pick a kind (D = door), then click near a wall. Drag a placed opening to slide it along the wall.</p>
    </section>
  )
}
